var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.038,
    height: 60.516,
    viewBox: "0 0 66.038 60.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(-1464.557 7476.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-image",
    "data-name": "Icon metro-image",
    d: "M56.878,7.477l.007.007V50.922l-.007.007H6.2l-.006-.007V7.483L6.2,7.477Zm.007-3.621H6.192A3.632,3.632,0,0,0,2.571,7.477V50.928a3.632,3.632,0,0,0,3.621,3.621H56.884A3.632,3.632,0,0,0,60.5,50.928V7.477a3.632,3.632,0,0,0-3.621-3.621ZM49.643,16.529A5.431,5.431,0,1,1,44.211,11.1a5.431,5.431,0,0,1,5.432,5.429Zm3.621,30.778H9.813V40.065L22.486,18.34,36.97,36.44h3.62L53.264,25.582Z",
    transform: "translate(1470.095 -7470.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-circle",
    "data-name": "Icon feather-plus-circle",
    transform: "translate(1464.557 -7476.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M25,14a11.119,11.119,0,0,1-4.3,8.725A10.759,10.759,0,0,1,14,25,11,11,0,1,1,25,14Z",
    transform: "translate(-3 -3)",
    fill: "#7315ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M18,12v8.8",
    transform: "translate(-6.997 -5.399)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M12,18h8.8",
    transform: "translate(-5.398 -6.998)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDrop);
export default __webpack_public_path__ + "static/media/image_drop.b0c08adbfa6a1e677c35db396cd3f46a.svg";
export { ForwardRef as ReactComponent };